export default __webpack_public_path__ + "static/7-0af5115454715cfa24cbec704812c96c.webp";